export default __webpack_public_path__ + "static/media/new-ci-back-ejemplo-2.eeac80a6.jpeg";